module.exports = __webpack_public_path__ + "img/custom.7696ce44.png";